export var TABLE_CONTROLLER_CELL_CLASS_PREFIX = 'TableControllerCell';